module.exports = __webpack_public_path__ + "img/lbl-01.acb39093.png";